import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const dashboardLocaleModule: LocaleModule = {
  name: "dashboard",
  messages: { en: en, it: it },
};
